export const MILES_TO_KM = 1.60934;

export const convertMilesToKm = (miles: number): number => miles * MILES_TO_KM;

export const convertKmToMiles = (km: number): number => km / MILES_TO_KM;
